module.exports = __webpack_public_path__ + "static/img/Report-Preview.975738c.png";